import { ExternalLink, Loader2 } from "lucide-react";

export default function NewsFeed({ items, loading, selected, onSelect }) {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-muted-foreground">
        <Loader2 className="w-6 h-6 animate-spin mb-3" aria-hidden="true" />
        <p className="font-mono text-xs uppercase tracking-wider">Fetching latest news…</p>
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="flex items-center justify-center h-full text-muted-foreground">
        <p className="font-mono text-xs uppercase tracking-wider">No news found. Try another category.</p>
      </div>
    );
  }

  return (
    <div className="divide-y divide-border">
      {items.map((item, i) => {
        const active = selected?.id === item.id;
        return (
          <article
            key={item.id}
            data-testid={`news-item-${i}`}
            onClick={() => onSelect(item)}
            style={{ animationDelay: `${Math.min(i, 10) * 25}ms` }}
            className={`p-5 cursor-pointer transition-colors animate-fade-up ${
              active ? "bg-[#FFF9E0] border-l-4 border-l-[#ffce00]" : "border-l-4 border-l-transparent hover:bg-secondary"
            }`}
          >
            <div className="flex gap-4">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span className="font-mono text-[10px] uppercase tracking-wider text-[#111110] font-semibold">
                    {item.source}
                  </span>
                  {item.published && (
                    <span className="font-mono text-[10px] text-muted-foreground">
                      · {new Date(item.published).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })}
                    </span>
                  )}
                </div>
                <h3 className="font-heading font-bold text-base leading-snug mb-2">{item.title}</h3>
                {item.summary && (
                  <p className="text-sm text-muted-foreground leading-relaxed line-clamp-2">{item.summary}</p>
                )}
              </div>
              {item.thumbnail && (
                <img
                  src={item.thumbnail}
                  alt=""
                  aria-hidden="true"
                  loading="lazy"
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                  className="w-28 h-20 sm:w-32 sm:h-24 object-cover border border-border shrink-0 bg-secondary"
                />
              )}
            </div>
            <div className="flex items-center gap-4 mt-3">
              <span
                className={`font-mono text-[10px] uppercase tracking-wider px-2 py-1 border ${
                  active ? "bg-[#111110] text-[#ffce00] border-[#111110]" : "border-border text-muted-foreground"
                }`}
              >
                {active ? "✓ Selected" : "Select"}
              </span>
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                data-testid={`news-source-link-${i}`}
                className="font-mono text-[10px] text-muted-foreground hover:text-[#111110] flex items-center gap-1"
              >
                Source <ExternalLink className="w-3 h-3" aria-hidden="true" />
              </a>
            </div>
          </article>
        );
      })}
    </div>
  );
}
